import React, { useMemo } from 'react';
import { titlePaths } from '@warehouse/title/core';
import { TitleTextInputField } from '@warehouse/title/ui';

export function DisplayTitleField({ localizedInfoUuid }: { localizedInfoUuid: string }) {
	const path = useMemo(() => titlePaths.titleDisplayUnlimited(localizedInfoUuid), [localizedInfoUuid]);

	return <TitleTextInputField label="Display Title" ariaLabel="Display Title" path={path} />;
}
